module.exports = __webpack_public_path__ + "img/Acounto_logo.e1425797.svg";